module.exports = __webpack_public_path__ + "img/gc_country_flag_mc.38a65e0e.svg";